<template>
  <div id="app-root">
    <NavBar v-if="showNav" />
    <div :class="isAuthRoute ? 'auth-shell' : 'main-shell'">
      <router-view />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import NavBar from './components/NavBar.vue'

const route = useRoute()

const isAuthRoute = computed(() =>
  ['/login', '/callback', '/pending', '/select-college', '/workshop-status'].includes(route.path),
)

const showNav = computed(() => !['/login', '/callback'].includes(route.path))
</script>

<style scoped>
#app-root {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>
